export default __webpack_public_path__ + "static/kb_3_10-ca804b298d91cf6ea15174e44a0bdd51.jpg";